import React, { useEffect, useState,useCallback } from "react";
import Security from "./Security";
import Footer from "./Footer";
import axios from "axios";
import secureLocalStorage from "./storage";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Manubar from "./Manubar";
import "react-tabs/style/react-tabs.css";
import WithdrawDialog from "./WithdrawDialog";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Paper,
  Menu,
  MenuItem,
  IconButton,
  Grid,
  Dialog,
  DialogContent,
  Chip,
} from "@mui/material";
import {
  Person,
  MoreVert,
  CheckCircle,
  HourglassEmpty,
  AccountBalanceWallet,
  ShoppingBag,
  Cancel,
  Close,
  ChevronRight,
  HelpOutline,
} from "@mui/icons-material";
import TransactionTable from "./TransactionTable";
import UserProfile from "./UserProfile";

import MissingCashback from "./MissingCashback";
import Help from "./Help";
import HelpContent from "./HelpContent";

const Myaccount = () => {
  let Navigate = useNavigate();
  const location = useLocation();
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");
  let [get_user_profile, setget_user_profile] = useState([]);
  // const [activeTab, setActiveTab] = useState(location.state || "dashboard");
  const [activeTab, setActiveTab] = useState(location.state?.tab || "dashboard");
  const [withdrawOpen, setWithdrawOpen] = useState(false);
 const fmt = (n) => Number(n || 0).toFixed(2);
  useEffect(() => {
    if (location.state?.tab) {
      setActiveTab(location.state.tab);
    }
  }, [location.state?.tab]);   // 🟢 sirf tab value pe depend karo, poore object pe nahi
  const [walletSummary, setWalletSummary] = useState({
    wallet_balance: 0,
    all_time_earnings: 0,
    cashback: 0,
    rewards: 0,
    referral: 0,
    confirmed_balance: 0,
    pending_orders_count: 0,
    pending_withdrawal: 0,
    withdrawn: 0,
    min_withdrawal: 100,
  });
  const [breakupOpen, setBreakupOpen] = useState(false);
  const [breakupType, setBreakupType] = useState("Cashback");

  const handleBreakupOpen = (type) => {
    setBreakupType(type);
    setBreakupOpen(true);
  };

  const handleBreakupClose = () => {
    setBreakupOpen(false);
  };
  const isCashback = breakupType === "Cashback";
  const breakupEarned =
    breakupType === "Cashback" ? walletSummary?.cashback
      : breakupType === "Rewards" ? walletSummary?.rewards
        : walletSummary?.referral;
  // Mobile menu state
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);
  const [paymentPopupOpen, setPaymentPopupOpen] = useState(false);
  const [withdrawals, setWithdrawals] = useState([]);

  const fetchWithdrawals = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}website/my_withdrawals`,
        { headers: { token } }
      );
      if (res.data?.success) setWithdrawals(res.data.data);
    } catch (error) {
      console.error("Error fetching withdrawals:", error);
    }
  };

  useEffect(() => {
    if (paymentPopupOpen) fetchWithdrawals();
  }, [paymentPopupOpen]);

const fetchUserProfile = useCallback(async () => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API}website/get_user_profile`,
      { user_id: _id },
      { headers: { token } }
    );
    if (res.data.result) {
      setget_user_profile(res.data.data);
    }
  } catch (error) {
    console.log("Error fetching profile", error);
  }
}, [_id, token]);

useEffect(() => {
  fetchUserProfile();

  const handler = () => fetchUserProfile();
  window.addEventListener("profile-updated", handler);
  return () => window.removeEventListener("profile-updated", handler);
}, [fetchUserProfile]);


  let Logout = () => {
    try {
      let item = {
        _id: _id,
      };
      axios
        .post(`${process.env.REACT_APP_API}website/logout`, item)
        .then((res) => {
          if (res.data.result) {
            localStorage.removeItem("ssstoken");
            secureLocalStorage.removeItem("n_id");
            secureLocalStorage.removeItem("n_token");
            secureLocalStorage.removeItem("n_mobile_no");
            secureLocalStorage.removeItem("n_otp");
            Navigate(`/`);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) { }
  };

  const fetchWalletSummary = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}website/my_wallet_summary`,
        { headers: { token } }
      );
      if (res.data?.success) {
        setWalletSummary(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching wallet summary:", error);
    }
  };

  useEffect(() => {
    if (activeTab === "dashboard") {
      console.log("Dashboard");
      fetchWalletSummary();
    }

    if (activeTab === "orders") {
      console.log(activeTab);
    }

    if (activeTab === "transactions") {
      console.log(activeTab);
    }

    if (activeTab === "address") {
      console.log(activeTab);
    }

  }, [activeTab]);

  // Mobile menu handlers
  const handleMobileMenuOpen = (event) => {
    setMobileMenuAnchor(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuAnchor(null);
  };

  const handleMobileMenuItemClick = (tab) => {
    setActiveTab(tab);
    handleMobileMenuClose();
  };

  return (
    <div>
      <div>
        <div className="modal fade offcanvas-modal" id="exampleModal">
          <div className="modal-dialog offcanvas-dialog">
            <div className="modal-content">
              <Manubar />
            </div>
          </div>
        </div>
        <nav className="breadcrumb-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    my account
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </nav>
        <div className="my-account section-mb">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="title text-capitalize mb-5 pb-4">
                    my account
                  </h3>

                  {/* Mobile Menu Button - Only visible on small screens */}
                  <div className="d-lg-none mb-5">
                    <IconButton
                      onClick={handleMobileMenuOpen}
                      sx={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "8px",
                      }}
                    >
                      <MoreVert />
                    </IconButton>

                    <Menu
                      anchorEl={mobileMenuAnchor}
                      open={Boolean(mobileMenuAnchor)}
                      onClose={handleMobileMenuClose}
                      PaperProps={{ style: { width: "250px", maxHeight: "400px" } }}
                    >
                      <MenuItem onClick={() => handleMobileMenuItemClick("profile")}>
                        <i className="fa fa-user me-2" /> Account Settings
                      </MenuItem>
                      <MenuItem onClick={() => handleMobileMenuItemClick("dashboard")}>
                        <i className="fa fa-tachometer me-2" /> My Earnings
                      </MenuItem>
                      <MenuItem onClick={() => handleMobileMenuItemClick("transactions")}>
                        <i className="fa fa-credit-card me-2" /> Payments History
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setActiveTab("dashboard");
                          setPaymentPopupOpen(true);
                          handleMobileMenuClose();
                        }}
                      >
                        <i className="fa fa-inr me-2" /> Payments
                      </MenuItem>

                      {/* ⬇️ Redirect wale items */}
                      <MenuItem
                        onClick={() => {
                          Navigate("/help/missing-cashback");
                          handleMobileMenuClose();
                        }}
                      >
                        <i className="fa fa-ticket me-2" /> Missing Cashback
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          Navigate("/refer-and-earn");
                          handleMobileMenuClose();
                        }}
                      >
                        <i className="fa fa-user-plus me-2" /> Refer & Earn
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          Navigate("/my-referrals");
                          handleMobileMenuClose();
                        }}
                      >
                        <i className="fa fa-users me-2" /> My Referrals
                      </MenuItem>

                      {/* <MenuItem onClick={() => handleMobileMenuItemClick("changePin")}>
    <i className="fa fa-user me-2" /> Change Pin
  </MenuItem> */}

                      <MenuItem
                        onClick={() => {
                          Navigate("/help");
                          handleMobileMenuClose();
                        }}
                      >
                        <i className="fa fa-question-circle me-2" /> Help
                      </MenuItem>

                      <MenuItem
                        onClick={() => {
                          Navigate("/reviews-us");
                          handleMobileMenuClose();
                        }}
                      >
                        <i className="fa fa-star me-2" /> Review Us
                      </MenuItem>

                      <MenuItem
                        onClick={() => {
                          Navigate("/privacy-policy");
                          handleMobileMenuClose();
                        }}
                      >
                        <i className="fa fa-user-secret me-2" /> Privacy Policy
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          Navigate("/terms-and-conditions");
                          handleMobileMenuClose();
                        }}
                      >
                        <i className="fa fa-cogs me-2" /> Terms & Conditions
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          Navigate("/aboutus");
                          handleMobileMenuClose();
                        }}
                      >
                        <i className="fa fa-info-circle me-2" /> About Us
                      </MenuItem>
                      <MenuItem onClick={Logout}>
                        <i className="fa fa-sign-out me-2" /> Logout
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-12 mb-5 d-none d-lg-block">
                <div className="myaccount-tab-menu nav" role="tablist">
                  <Link
                    onClick={() => setActiveTab("profile")}
                    className={activeTab === "profile" ? "active" : ""}
                  >
                    <i className="fa fa-user" aria-hidden="true"></i> Account Settings
                  </Link>

                  <Link
                    onClick={() => setActiveTab("dashboard")}
                    className={activeTab === "dashboard" ? "active" : ""}
                  >
                    <i className="fa fa-tachometer" /> My Earnings
                  </Link>

                  <Link
                    onClick={() => setActiveTab("transactions")}
                    className={activeTab === "transactions" ? "active" : ""}
                  >
                    <i className="fa fa-credit-card" /> Payments History
                  </Link>

                  <Link
                    onClick={() => {
                      setActiveTab("dashboard");
                      setPaymentPopupOpen(true);
                    }}
                  >
                    <i className="fa fa-inr" /> Payments
                  </Link>

                  <Link to="/help/missing-cashback">
                    <i className="fa fa-ticket" /> Missing Cashback
                  </Link>
                  <Link to="/refer-and-earn">
                    <i className="fa fa-user-plus" /> Refer & Earn
                  </Link>
                  <Link to="/my-referrals">
                    <i className="fa fa-users" /> My Referrals
                  </Link>
                  <Link to="/help">
                    <i className="fa fa-question-circle" aria-hidden="true"></i> Help
                  </Link>
                  <Link to="/reviews-us">
                    <i className="fa fa-star" aria-hidden="true"></i> Review Us
                  </Link>

                  <Link to="/privacy-policy">
                    <i className="fa fa-user-secret" aria-hidden="true"></i> Privacy-Policy
                  </Link>
                  <Link to="/terms-and-conditions">
                    <i className="fa fa-cogs" aria-hidden="true"></i> Terms-And-Condition
                  </Link>
                  <Link to="/aboutus">
                    <i className="fa fa-info-circle" aria-hidden="true"></i> About-Us
                  </Link>

                  <Link onClick={Logout}>
                    <i className="fa fa-sign-out" /> Logout
                  </Link>
                </div>
              </div>

              <div className="col-lg-9 col-12 mb-5">
                <div className="tab-content" id="myaccountContent">
                  {/* Your existing tab content remains the same */}
                  {activeTab === "dashboard" && (
                    <Box sx={{ p: { xs: 2, sm: 3 } }}>
                      {/* Welcome Card */}
                      <Card
                        elevation={0}
                        sx={{
                          mb: 4,
                          background: "var(--primary-gradient)",
                          color: "#fff",
                        }}
                      >
                        <CardContent
                          sx={{ p: { xs: 3, sm: 4 }, textAlign: "center" }}
                        >
                          <Person
                            sx={{
                              fontSize: { xs: 48, sm: 64 },
                              mb: 2,
                              opacity: 0.9,
                            }}
                          />
                          <Typography
                            variant="h4"
                            component="h3"
                            gutterBottom
                            sx={{
                              fontWeight: 600,
                              fontSize: { xs: "1.75rem", sm: "2.125rem" },
                            }}
                          >
                            Welcome Back!
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{
                              opacity: 0.9,
                              mb: 2,
                              fontSize: { xs: "1rem", sm: "1.25rem" },
                            }}
                          >
                            Hello,{" "}
                            <strong>{get_user_profile?.full_name}</strong>
                          </Typography>

                        </CardContent>
                      </Card>
                      {/* CashKaro-style Earnings Section */}
                      <Card
                        elevation={2}
                        sx={{
                          borderRadius: 3,
                          background: "linear-gradient(135deg, #2f5bff 0%, #1a3fd6 100%)",
                          color: "white",
                          mb: 3,
                        }}
                      >
                        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: { xs: "column", sm: "row" },
                              alignItems: { xs: "flex-start", sm: "center" },
                              gap: { xs: 3, sm: 4 },
                            }}
                          >
                            {/* Left side - All time Earnings */}
                            <Box sx={{ flexShrink: 0, minWidth: { sm: 160 } }}>
                              <Typography variant="body1" sx={{ opacity: 0.9, mb: 0.5 }}>
                                All time Earnings
                              </Typography>
                              <Typography
                                variant="h4"
                                sx={{ fontWeight: "bold", fontSize: { xs: "1.8rem", sm: "2.1rem" } }}
                              >
                               ₹{fmt(walletSummary?.all_time_earnings)}
                              </Typography>
                            </Box>

                            {/* Right side - 3 boxes, equal width, fills remaining space */}
                            <Box
                              sx={{
                                display: "flex",
                                flex: 1,
                                width: "100%",
                                gap: 2,
                              }}
                            >
                              <Box
                                onClick={() => handleBreakupOpen("Cashback")}
                                sx={{
                                  flex: 1,
                                  background: "rgba(255,255,255,0.15)",
                                  borderRadius: 2,
                                  p: { xs: 2, sm: 3 },
                                  textAlign: "center",
                                  cursor: "pointer",
                                  transition: "0.2s",
                                  "&:hover": { background: "rgba(255,255,255,0.25)" },
                                }}
                              >
                                <ShoppingBag sx={{ fontSize: { xs: 26, sm: 32 }, mb: 1 }} />
                                <Typography sx={{ fontWeight: 600, fontSize: { xs: "0.85rem", sm: "1rem" } }}>
                                  Cashback
                                </Typography>
                                <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.25rem" } }}>
                                  ₹{fmt(walletSummary?.cashback)}
                                </Typography>
                              </Box>

                              <Box
                                onClick={() => handleBreakupOpen("Rewards")}
                                sx={{
                                  flex: 1,
                                  background: "rgba(255,255,255,0.15)",
                                  borderRadius: 2,
                                  p: { xs: 2, sm: 3 },
                                  textAlign: "center",
                                  cursor: "pointer",
                                  transition: "0.2s",
                                  "&:hover": { background: "rgba(255,255,255,0.25)" },
                                }}
                              >
                                <CheckCircle sx={{ fontSize: { xs: 26, sm: 32 }, mb: 1 }} />
                                <Typography sx={{ fontWeight: 600, fontSize: { xs: "0.85rem", sm: "1rem" } }}>
                                  Rewards
                                </Typography>
                                <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.25rem" } }}>
                                  ₹{fmt(walletSummary?.rewards)}
                                </Typography>
                              </Box>

                              <Box
                                onClick={() => handleBreakupOpen("Referral")}
                                sx={{
                                  flex: 1,
                                  background: "rgba(255,255,255,0.15)",
                                  borderRadius: 2,
                                  p: { xs: 2, sm: 3 },
                                  textAlign: "center",
                                  cursor: "pointer",
                                  transition: "0.2s",
                                  "&:hover": { background: "rgba(255,255,255,0.25)" },
                                }}
                              >
                                <Cancel sx={{ fontSize: { xs: 26, sm: 32 }, mb: 1 }} />
                                <Typography sx={{ fontWeight: 600, fontSize: { xs: "0.85rem", sm: "1rem" } }}>
                                  Referral
                                </Typography>
                                <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.25rem" } }}>
                                 ₹{fmt(walletSummary?.referral)}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>

                          <Typography
                            variant="caption"
                            sx={{
                              display: "block",
                              textAlign: "center",
                              mt: 3,
                              pt: 2,
                              borderTop: "1px solid rgba(255,255,255,0.25)",
                              opacity: 0.85,
                            }}
                          >
                            *Earnings will show here within 72 hours of your booking
                          </Typography>
                        </CardContent>
                      </Card>
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
                          gap: 3,
                          mb: 3,
                        }}
                      >
                        {/* Confirmed */}
                        <Card elevation={1} sx={{ borderRadius: 3, border: "1px solid #eee" }}>
                          <CardContent sx={{ p: 3, textAlign: "center" }}>
                            <CheckCircle sx={{ fontSize: 40, color: "#22c55e", mb: 1 }} />
                            <Typography sx={{ fontWeight: 600, mb: 0.5 }}>Confirmed</Typography>
                            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                              ₹{Number(walletSummary?.confirmed_balance || 0).toFixed(2)}
                            </Typography>
                            <Button
                              variant="contained"
                              fullWidth
                              disabled={(walletSummary?.pending_withdrawal || 0) > 0}
                              onClick={() => setWithdrawOpen(true)}
                              sx={{
                                backgroundColor: "#2f5bff",
                                "&:hover": { backgroundColor: "#1a3fd6" },
                              }}
                            >
                              {(walletSummary?.pending_withdrawal || 0) > 0
                                ? `₹${Number(walletSummary.pending_withdrawal).toFixed(2)} withdrawal in process`
                                : "Withdraw"}
                            </Button>
                          </CardContent>
                        </Card>

                        {/* Pending */}
                        <Card elevation={1} sx={{ borderRadius: 3, border: "1px solid #eee" }}>
                          <CardContent sx={{ p: 3, textAlign: "center" }}>
                            <HourglassEmpty sx={{ fontSize: 40, color: "#2f5bff", mb: 1 }} />
                            <Typography sx={{ fontWeight: 600, mb: 0.5 }}>Pending</Typography>
                            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                              {walletSummary?.pending_orders_count || 0}
                            </Typography>
                            <Button
                              variant="outlined"
                              fullWidth
                              sx={{
                                color: "#2f5bff",
                                borderColor: "#2f5bff",
                                "&:hover": { borderColor: "#1a3fd6" },
                              }}
                            >
                              Know Why?
                            </Button>
                          </CardContent>
                        </Card>

                        {/* Withdrawn */}
                        <Card elevation={1} sx={{ borderRadius: 3, border: "1px solid #eee" }}>
                          <CardContent sx={{ p: 3, textAlign: "center" }}>
                            <AccountBalanceWallet sx={{ fontSize: 40, color: "#22c55e", mb: 1 }} />
                            <Typography sx={{ fontWeight: 600, mb: 0.5 }}>Withdrawn</Typography>
                            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                              ₹{fmt(walletSummary?.withdrawn)}
                            </Typography>
                            <Button
                              variant="outlined"
                              fullWidth
                              onClick={() => setPaymentPopupOpen(true)}
                              sx={{
                                color: "#22c55e",
                                borderColor: "#22c55e",
                                "&:hover": { borderColor: "#16a34a" },
                              }}
                            >
                              View Payments
                            </Button>
                          </CardContent>
                        </Card>
                      </Box>

                      <Stack spacing={2}>
                        <Card
                          elevation={0}
                          onClick={() => Navigate("/my-earnings/order-details")}
                          sx={{
                            border: "1px solid #eee",
                            borderRadius: 3,
                            cursor: "pointer",
                            "&:hover": { borderColor: "#2f5bff" },
                          }}
                        >
                          <CardContent
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              p: "16px !important",
                            }}
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <ShoppingBag sx={{ color: "#000" }} />
                              <Typography sx={{ fontWeight: 600 }}>My Order Details</Typography>
                            </Stack>
                            <ChevronRight sx={{ color: "#888" }} />
                          </CardContent>
                        </Card>

                        <Card
                          elevation={0}
                          onClick={() => Navigate("/help/gethelp")}
                          sx={{
                            border: "1px solid #eee",
                            borderRadius: 3,
                            cursor: "pointer",
                            "&:hover": { borderColor: "#2f5bff" },
                          }}
                        >
                          <CardContent
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              p: "16px !important",
                            }}
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <HelpOutline sx={{ color: "#000" }} />
                              <Typography sx={{ fontWeight: 600 }}>Get Help</Typography>
                            </Stack>
                            <ChevronRight sx={{ color: "#888" }} />
                          </CardContent>
                        </Card>
                      </Stack>


                    </Box>
                  )}
                  {/* Breakup Popup - Cashback/Rewards/Referral */}
                  <Dialog
                    open={breakupOpen}
                    onClose={handleBreakupClose}
                    maxWidth="xs"
                    fullWidth
                  >
                    <DialogContent sx={{ p: 3, position: "relative" }}>
                      <IconButton
                        onClick={handleBreakupClose}
                        sx={{ position: "absolute", right: 12, top: 12 }}
                      >
                        <Close />
                      </IconButton>

                      <Typography variant="h6" sx={{ fontWeight: 700, mb: 3, textAlign: "center" }}>
                        {breakupType} Breakup
                      </Typography>

                      <Stack spacing={2} sx={{ mb: 3 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center"
                          sx={{ borderBottom: "1px solid #eee", pb: 1.5 }}>
                          <Box>
                            <Typography sx={{ fontWeight: 700 }}>₹{fmt(breakupEarned)}</Typography>
                            <Typography variant="caption" color="text.secondary">Total {breakupType} earned</Typography>
                          </Box>
                        </Stack>

                        <Stack direction="row" justifyContent="space-between" alignItems="center"
                          sx={{ borderBottom: "1px solid #eee", pb: 1.5 }}>
                          <Box>
                            <Typography sx={{ fontWeight: 700 }}>
                              {/* {isCashback ? `₹${walletSummary?.confirmed_balance || 0}` : "--"} */}
                              {isCashback ? `₹${fmt(walletSummary?.confirmed_balance)}` : "--"}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">Available for Withdrawal</Typography>
                          </Box>
                          <Chip label="Confirmed" size="small"
                            sx={{ backgroundColor: "#e8f8ef", color: "#22c55e", fontWeight: 600 }} />
                        </Stack>

                        <Stack direction="row" justifyContent="space-between" alignItems="center"
                          sx={{ borderBottom: "1px solid #eee", pb: 1.5 }}>
                          <Box>
                            <Typography sx={{ fontWeight: 700 }}>
                              {isCashback ? `${walletSummary?.pending_orders_count || 0} orders` : "--"}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">Waiting for confirmation</Typography>
                          </Box>
                          <Chip label="Pending" size="small"
                            sx={{ backgroundColor: "#fff8e1", color: "#f59e0b", fontWeight: 600 }} />
                        </Stack>

                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Box>
                            <Typography sx={{ fontWeight: 700 }}>
                            {isCashback ? `₹${fmt(walletSummary?.withdrawn)}` : "--"}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">Already paid to you</Typography>
                          </Box>
                          <Chip label="Paid" size="small"
                            sx={{ backgroundColor: "#e8eeff", color: "#2f5bff", fontWeight: 600 }} />
                        </Stack>
                      </Stack>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        <strong>Confirmed {breakupType}:</strong> Earnings after the
                        return/cancellation period, which is available for withdrawal via bank
                        transfer, UPI or NEFT. You will need a minimum of ₹{walletSummary?.min_withdrawal || 100} confirmed{" "}
                        {breakupType} to proceed.
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        <strong>Pending {breakupType}:</strong> Earnings before the
                        return/cancellation period.
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 3 }}>
                        <strong>Paid {breakupType}:</strong> Earnings that have already been
                        paid to you.
                      </Typography>

                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleBreakupClose}
                        sx={{
                          backgroundColor: "#2f5bff",
                          "&:hover": { backgroundColor: "#1a3fd6" },
                          py: 1.2,
                        }}
                      >
                        Ok, Got It
                      </Button>
                    </DialogContent>
                  </Dialog>
                  <WithdrawDialog
                    open={withdrawOpen}
                    onClose={() => setWithdrawOpen(false)}
                    balance={walletSummary?.confirmed_balance || 0}
                    minAmount={walletSummary?.min_withdrawal || 100}
                    defaultName={get_user_profile?.full_name || ""}
                    onSuccess={fetchWalletSummary}
                  />
                  {/* Payment Status Popup */}
                  <Dialog
                    open={paymentPopupOpen}
                    onClose={() => setPaymentPopupOpen(false)}
                    maxWidth="xs"
                    fullWidth
                  >
                    <DialogContent sx={{ p: 4, textAlign: "center", position: "relative" }}>
                      <IconButton
                        onClick={() => setPaymentPopupOpen(false)}
                        sx={{ position: "absolute", right: 12, top: 12 }}
                      >
                        <Close />
                      </IconButton>

                      {/* {paymentStatus === "none" && (
                            <>
                              <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} sx={{ mb: 2 }}>
                                <Box sx={{ width: 64, height: 64, borderRadius: "50%", backgroundColor: "#e8eeff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <ShoppingBag sx={{ fontSize: 32, color: "#2f5bff" }} />
                                </Box>
                                <Box sx={{ width: 64, height: 64, borderRadius: "50%", backgroundColor: "#e8f8ef", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <AccountBalanceWallet sx={{ fontSize: 32, color: "#22c55e" }} />
                                </Box>
                              </Stack>
                              <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                                No Payment Yet!
                              </Typography>
                              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                You haven't received any payment so far.
                                <br />
                                Place your first order today & get paid, feels amazing! 😊
                              </Typography>
                              <Box sx={{ background: "#f5f5f5", borderRadius: 2, p: 1.5, mb: 3 }}>
                                <Typography variant="body2">
                                  <strong>Note</strong> - Once shopped, payment tracks within 5 mins to 48 hrs
                                </Typography>
                              </Box>
                              <Button
                                variant="contained"
                                fullWidth
                                onClick={() => { setPaymentPopupOpen(false); Navigate("/"); }}
                                sx={{ backgroundColor: "#2f5bff", "&:hover": { backgroundColor: "#1a3fd6" }, py: 1.2 }}
                              >
                                Start Shopping
                              </Button>
                            </>
                          )}

                          {paymentStatus === "pending" && (
                            <>
                              <Box sx={{ width: 72, height: 72, borderRadius: "50%", backgroundColor: "#fff8e1", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
                                <HourglassEmpty sx={{ fontSize: 36, color: "#f59e0b" }} />
                              </Box>
                              <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                                Payment Not Confirmed!
                              </Typography>
                              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                You have <strong>₹{paymentAmount}</strong> pending in your account.
                                <br />
                                Once confirmed, they can be withdrawn. Until then, grab deals & earn more!
                              </Typography>
                              <Button
                                variant="contained"
                                fullWidth
                                onClick={() => { setPaymentPopupOpen(false); Navigate("/"); }}
                                sx={{ backgroundColor: "#2f5bff", "&:hover": { backgroundColor: "#1a3fd6" }, py: 1.2 }}
                              >
                                Browse Deals
                              </Button>
                            </>
                          )}

                          {paymentStatus === "confirmed" && (
                            <>
                              <Box sx={{ width: 72, height: 72, borderRadius: "50%", backgroundColor: "#e8f8ef", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
                                <CheckCircle sx={{ fontSize: 36, color: "#22c55e" }} />
                              </Box>
                              <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                                Payment Confirmed!
                              </Typography>
                              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                ₹{paymentAmount} is confirmed and available for withdrawal.
                              </Typography>
                              <Button
                                variant="contained"
                                fullWidth
                                onClick={() => setPaymentPopupOpen(false)}
                                sx={{ backgroundColor: "#2f5bff", "&:hover": { backgroundColor: "#1a3fd6" }, py: 1.2 }}
                              >
                                Ok, Got It
                              </Button>
                            </>
                          )} */}
                      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, textAlign: "center" }}>
                        My Payments
                      </Typography>

                      {withdrawals.length === 0 ? (
                        <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", mb: 2 }}>
                          No withdrawals yet. Withdraw your confirmed cashback to see payments here.
                        </Typography>
                      ) : (
                        <Stack spacing={1.5} sx={{ mb: 2 }}>
                          {withdrawals.map((w) => (
                            <Box key={w._id} sx={{ border: "1px solid #eee", borderRadius: 2, p: 1.5 }}>
                              <Stack direction="row" justifyContent="space-between" alignItems="center">
                              <Typography sx={{ fontWeight: 700 }}>₹{fmt(w.amount)}</Typography>
                                <Chip
                                  size="small"
                                  label={w.status === "paid" ? "Paid" : w.status === "rejected" ? "Rejected" : "Pending"}
                                  sx={{
                                    fontWeight: 600,
                                    backgroundColor: w.status === "paid" ? "#e8f8ef" : w.status === "rejected" ? "#fdecea" : "#fff8e1",
                                    color: w.status === "paid" ? "#22c55e" : w.status === "rejected" ? "#d32f2f" : "#f59e0b",
                                  }}
                                />
                              </Stack>
                              <Typography variant="caption" color="text.secondary" display="block">
                                {new Date(w.createdAt).toLocaleDateString()}
                                {w.status === "paid" && w.utr ? ` • Ref: ${w.utr}` : ""}
                                {w.status === "rejected" && w.reject_reason ? ` • ${w.reject_reason}` : ""}
                              </Typography>
                            </Box>
                          ))}
                        </Stack>
                      )}

                      <Button
                        variant="contained"
                        fullWidth
                        onClick={() => setPaymentPopupOpen(false)}
                        sx={{ backgroundColor: "#2f5bff", "&:hover": { backgroundColor: "#1a3fd6" }, py: 1.2 }}
                      >
                        Ok, Got It
                      </Button>
                    </DialogContent>
                  </Dialog>
                  {/* {activeTab === "orders" && <Orders />} */}

                  {activeTab === "transactions" && <TransactionTable />}

                  {/* {activeTab === "address" && <Address />} */}
                  {activeTab === "profile" && <UserProfile />}


                </div>
              </div>
            </div>
          </div>
        </div>

        <Security />
        <Footer />
      </div>
    </div>
  );
};

export default Myaccount;
